const getters = {
  sidebar: state => state.app.sidebar,
  taskbar: state => state.app.taskbar,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  token: state => state.user.token,
  name: state => state.user.name,
  userinfo: state => state.user.userinfo,
  addRouters: state => state.permission.addRouters,
  size: state => state.app.size,
  cachedViews: state => state.tagsView.cachedViews,
  reLogin: state => state.user.reLogin
}
export default getters
